import performanceReducer from "../performanceReducer";

const performanceReducers = {
  performance: performanceReducer,
};

export default performanceReducers;
